var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 15.4419H22.8V24.5584H21.3231V21.4596C21.3214 19.7038 20.7054 18.0206 19.6104 16.7791C18.5153 15.5375 17.0306 14.8392 15.4819 14.8372H12.1333V10H10V36H12.1333V32.3915L39.8667 32.6431V36H42V21.4884C41.9984 19.8853 41.436 18.3484 40.4361 17.2149C39.4363 16.0813 38.0807 15.4437 36.6667 15.4419ZM12.1333 17.2558H15.4819C16.465 17.2571 17.4074 17.7004 18.1025 18.4884C18.7976 19.2765 19.1886 20.3449 19.1897 21.4594V24.5583H12.1333V17.2558ZM39.8667 30.2244L12.1333 29.9728V26.977H39.8667V30.2244ZM39.8667 24.5584H24.9333V17.8605H36.6667C37.5151 17.8616 38.3284 18.2441 38.9283 18.9243C39.5282 19.6044 39.8657 20.5265 39.8667 21.4884V24.5584Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBed);
export default __webpack_public_path__ + "static/media/singleBed.7669fad77eab4ca7f6e3788ce580da6e.svg";
export { ForwardRef as ReactComponent };